import { render } from "./NewTurbineModelModal.vue?vue&type=template&id=c88de210&scoped=true&ts=true"
import script from "./NewTurbineModelModal.vue?vue&type=script&lang=ts"
export * from "./NewTurbineModelModal.vue?vue&type=script&lang=ts"

import "./NewTurbineModelModal.vue?vue&type=style&index=0&id=c88de210&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88de210"]])

export default __exports__